<app-spinner></app-spinner>

<div class="track-container position-relative text-center">
  <img
    src="/assets/img/resources/track/track_banner.jpg"
    alt="LOGO Cargo tracking banner"
    class="img-fluid"
  />
</div>

<section class="unreg-track-page py-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-9 col-lg-10">
        <div class="text-center mb-5">
          <h1 class="unreg-heading mb-3">Track Your Abandoned Box</h1>
          <p class="text-muted mb-2">
            LOGO Cargo is helping return abandoned boxes that have been transferred to our warehouse for
            free distribution.
          </p>
          <p class="text-muted mb-0">
            This program is carried out in support of the Bureau of Customs (BOC), Department of Migrant Workers (DMW),
            and our hardworking OFWs, with the support of our CEO, Mr. Joel P. Longares. We will never ask you to pay
            any delivery fees for these boxes.
          </p>
        </div>

        <div class="row g-4 align-items-start">
          <!-- Trust / info -->
          <div class="col-lg-5">
            <div class="unreg-info-card card border-0 shadow-sm h-100">
              <div class="card-body">
                <h5 class="fw-semibold text-primary mb-3">How this service works</h5>
                <p class="text-muted mb-3">
                  Some balikbayan boxes were left unclaimed or abandoned and turned over to our warehouse.
                  We work with the authorities to locate and deliver them to their rightful recipients at no cost.
                </p>
                <ul class="list-unstyled text-muted small mb-0">
                  <li class="mb-2">
                    <i class="bi bi-check-circle-fill text-primary me-2"></i>
                    Coordinated with BOC and DMW for proper release.
                  </li>
                  <li class="mb-2">
                    <i class="bi bi-check-circle-fill text-primary me-2"></i>
                    No delivery or processing fees are collected from recipients.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill text-primary me-2"></i>
                    Use this page to check the current status of an abandoned box.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Form + results -->
          <div class="col-lg-7">
            <div class="card border-0 shadow-sm mb-4 unreg-form-card">
              <div class="card-body p-4">
                <h5 class="card-title text-dark mb-3">
                  <strong>Check Abandoned Box Status</strong>
                </h5>
                <p class="mb-3 text-muted">
                  Enter the tracking number from your box or notification to see its current status in our system.
                </p>

                <form
                  [formGroup]="unregBoxForm"
                  (ngSubmit)="trackUnregisteredBox()"
                  novalidate>
                  <div class="d-flex flex-column flex-sm-row gap-2">
                    <input
                      id="unregBoxTrackingNumber"
                      type="text"
                      class="form-control form-control-lg"
                      name="unreg_tracking_number"
                      placeholder="Enter unregistered box tracking number"
                      formControlName="trackingNumber" />
                    <button class="btn btn-gradient-primary btn-lg flex-shrink-0" type="submit">
                      Track Box
                    </button>
                  </div>
                </form>

                <div *ngIf="errorMsg" class="alert alert-warning py-2 mt-3 mb-0">
                  {{ errorMsg }}
                </div>
              </div>
            </div>

            <div *ngIf="unregBoxResult" class="card border-0 shadow-sm unreg-result-card">
              <div class="card-body p-4">
                <div class="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
                  <div>
                    <div class="text-muted small mb-1">Tracking Number</div>
                    <div class="fw-semibold fs-5">
                      {{ unregBoxResult.trackingNumber }}
                    </div>
                  </div>
                  <span
                    class="status-badge"
                    [ngClass]="{
                      'status-delivered': unregBoxResult.status === 'Delivered',
                      'status-out-for-delivery': unregBoxResult.status === 'Out for Delivery',
                      'status-processing': unregBoxResult.status === 'Warehouse Sorting and Processing',
                      'status-pending': unregBoxResult.status === 'No Warehouse Receiving'
                    }">
                    {{ unregBoxResult.status }}
                  </span>
                </div>

                <div class="row gy-2">
                  <div class="col-sm-6" *ngIf="unregBoxResult.consigneeName">
                    <div class="label text-muted small">Consignee Name</div>
                    <div class="value fw-medium">
                      {{ unregBoxResult.consigneeName }}
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="unregBoxResult.consigneePhone">
                    <div class="label text-muted small">Consignee Phone</div>
                    <div class="value">
                      {{ unregBoxResult.consigneePhone }}
                    </div>
                  </div>
                  <div class="col-12" *ngIf="unregBoxResult.consigneeAddress">
                    <div class="label text-muted small">Consignee Address</div>
                    <div class="value">
                      {{ unregBoxResult.consigneeAddress }}
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="unregBoxResult.noOfBoxes != null">
                    <div class="label text-muted small">No. of Boxes</div>
                    <div class="value">
                      {{ unregBoxResult.noOfBoxes }}
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="unregBoxResult.receivedAtWarehouse != null">
                    <div class="label text-muted small">Boxes Received at Warehouse</div>
                    <div class="value">
                      {{ unregBoxResult.receivedAtWarehouse }}
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="unregBoxResult.deliveredBoxes != null">
                    <div class="label text-muted small" *ngIf="unregBoxResult.status === 'Delivered'">Delivered Boxes</div>
                    <div class="label text-muted small" *ngIf="unregBoxResult.status !== 'Delivered'">No of Boxes</div>
                    <div class="value">
                      {{ unregBoxResult.deliveredBoxes }}
                    </div>
                  </div>
                  <div class="col-12" *ngIf="unregBoxResult.cargoCompany">
                    <div class="label text-muted small">Abandoned by</div>
                    <div class="value">
                      {{ unregBoxResult.cargoCompany }}
                    </div>
                  </div>
                </div>

                <div
                  class="mt-4 d-flex justify-content-between align-items-center"
                  *ngIf="unregBoxResult.status === 'Delivered' && unregBoxResult.photoUrls?.length">
                  <div class="fw-semibold">Proof of Delivery Photos</div>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm rounded-pill px-3"
                    (click)="openPodViewer(0)">
                    View Photos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- POD viewer -->
<div
  class="unreg-pod-backdrop"
  *ngIf="showPodViewer && unregBoxResult?.photoUrls?.length">
  <div class="unreg-pod-modal">
    <button
      type="button"
      class="btn-close unreg-pod-close"
      aria-label="Close"
      (click)="closePodViewer()">
    </button>
    <div class="unreg-pod-body">
      <div class="unreg-pod-image-wrapper">
        <img
          [src]="unregBoxResult.photoUrls[podIndex]"
          class="unreg-pod-image"
          alt="Proof of delivery photo" />
      </div>
      <div class="unreg-pod-controls d-flex justify-content-between align-items-center mt-2">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="prevPod()">
          ‹ Prev
        </button>
        <span class="small text-muted">
          {{ podIndex + 1 }} / {{ unregBoxResult.photoUrls.length }}
        </span>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="nextPod()">
          Next ›
        </button>
      </div>
    </div>
  </div>
</div>

